export default [
  {
    name: "杭州站",
    path: "/",
    routeName: "hangzhou",
    label: "杭州s82",
  },
  {
    name: "长沙站",
    path: "/changsha",
    routeName: "changsha",
    label: "长沙s82",
  },
  {
    name: "青岛站",
    path: "/qingdao",
    routeName: "qingdao",
    label: "青岛s82",
    // meta: {
    //   is2021: true,
    // },
  },
  {
    name: "成都站",
    path: "/chengdu",
    routeName: "chengdu",
    label: "成都s82",
    meta: {
      // is2021: true,
    },
  },
  {
    name: "上海站",
    path: "/shanghai",
    routeName: "shanghai",
    label: "上海s82",
    meta: {
      is2021: true,
    },
  },
  {
    name: "北京站",
    path: "/beijing",
    routeName: "beijing",
    label: "北京s82",
    meta: {
      is2021: true,
    },
  },
];
